/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { DashboardLayout, MenuType } from '../../../components/layout/dashboard/DashboardLayout'
import { AccountPersonalDetails } from '../../account/AccountPersonalDetails'

const PersonalDetails = () => {
    return (
        <DashboardLayout menuType={MenuType.myAccount}>
            <div
                css={css`
                    display: flex;
                    width: 100%;
                `}
            >
                <AccountPersonalDetails />
            </div>
        </DashboardLayout>
    )
}

export { PersonalDetails }
